import * as actionTypes from "./SuperAdminTypes";
import { Get, Post } from "../../helpers/apicalls/apicalls";
import { message } from "antd";

export const Get_Companies = (data, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_COMPANIES_LOADING });
    Post("/agents/user/admin/getCompanies", data, token)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_COMPANIES_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_COMPANIES_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_COMPANIES_FAILED });
      });
  };
};

export const Get_Companies_Details = (data, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_COMPANIES_DETAILS_LOADING });
    Post("/agents/user/admin/getCompaniesDetails", data, token)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_COMPANIES_DETAILS_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_COMPANIES_DETAILS_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_COMPANIES_DETAILS_FAILED });
      });
  };
};


export const addorEditPrompts = (data, token, handleCancel) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.BRAND_PORPMTS_LOADING });
    Post("/agents/user/admin/addAndEditBrandContent", data, token)
      .then(function (response) {
        if (response.status) {
          message.success('successfully');
          dispatch({
            type: actionTypes.BRAND_PORPMTS_SUCCESS,
            payload: response?.data,
          });
          handleCancel()
        } else {
          dispatch({ type: actionTypes.BRAND_PORPMTS_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.BRAND_PORPMTS_FAILED });
      });
  };
};
export const getPrompts = (data, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_BRAND_PORPMTS_LOADING });
    Post("/agents/user/admin/getBrandContent", data, token)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_BRAND_PORPMTS_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_BRAND_PORPMTS_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_BRAND_PORPMTS_FAILED });
      });
  };
};

